import { LoadableLazy } from '@confluence/loadable';

export const LazyWatchSettingsOverflowMenuShortcut = LoadableLazy<any>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-watch-settings-menu-shortcut" */ '../src/WatchSettingsOverflowMenuShortcut.tsx'
			)
		).WatchSettingsOverflowMenuShortcut,
});
